import cn from 'classnames';
import { useContext, useMemo, useRef } from 'react';

import { CustomerReportContext } from 'components/grace/Contexts';
import { ENTRANCE_STAGE_SLUG } from 'lib/constants';

import GraceContentHeader from './ContentHeader';
import GraceForm from './Form';
import ModalSwitcher from './ModalSwitcher';
import NavigationHeader from './NavigationHeader';

const GraceModal = () => {
  const { currentStage, closeReport } = useContext(CustomerReportContext);
  const transitionRef = useRef(null);

  const isEntranceStage = useMemo(() => {
    return currentStage && currentStage.slug === ENTRANCE_STAGE_SLUG;
  }, [currentStage]);

  const renderNavigation = () => {
    return (
      <>
        <NavigationHeader onDismiss={closeReport} />
      </>
    );
  };

  const onDismiss = () => {
    closeReport();
  };

  return (
    <>
      <ModalSwitcher
        showIcon={false}
        title="Grace"
        onDismiss={onDismiss}
        bodyPadding="p-0"
        bodyStyle="pb-10 bp1:pb-6"
        topBarStyle="hidden"
        explicitBodyStyle={true}
        explicitTopBarStyle={true}
        mainContentClass="show pointer-events-auto fixed bottom-4 right-4 left-auto w-[384px] max-h-[624px] ml-auto bg-white-100 rounded-t-lg rounded-lg border border-solid border-charcoal-50 shadow-xl"
        containerStyle={cn(
          !isEntranceStage ? 'h-screen top-0' : 'top-auto',
          'bottom-0 right-0 left-0 p-0'
        )}
        renderModalInCenter={false}
        contentClassname={
          'ml-auto rounded-t-lg border border-solid border-charcoal-50 max-h-screen'
        }
        explicitMainContentClass={true}
        transitionRef={transitionRef}
        navigationHeader={renderNavigation()}
        childrenContainerClassnames="w-full bp1:h-full bp1:max-h-[562px] bp1:max-w-sm bp1:overflow-y-auto"
      >
        <GraceContentHeader />
        <GraceForm />
      </ModalSwitcher>
    </>
  );
};

export default GraceModal;
